import { render, staticRenderFns } from "./CardKanban.vue?vue&type=template&id=6833e096&scoped=true"
import script from "./CardKanban.vue?vue&type=script&lang=js"
export * from "./CardKanban.vue?vue&type=script&lang=js"
import style0 from "./CardKanban.vue?vue&type=style&index=0&id=6833e096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6833e096",
  null
  
)

export default component.exports